import React from 'react';
import loadable from '@loadable/component';

import isNewConsumerApp from 'commons/isNewConsumerApp';
import useIsBrowser from 'hooks/useIsBrowser';

// In new Consumer app, we are using a newer version of Nuka Carousel, which
// uses a named export rather than a default export.
const NukaCarouselLib = isNewConsumerApp
  ? loadable(() => import('nuka-carousel').then(mod => mod.Carousel))
  : loadable(() => import('nuka-carousel'));

const NukaCarouselNew = props => {
  const isBrowser = useIsBrowser();

  if (!isBrowser) {
    return null;
  }

  return <NukaCarouselLib {...props} />;
};

const NukaCarousel = isNewConsumerApp ? NukaCarouselNew : NukaCarouselLib;

export default NukaCarousel;
